import { Caption } from '@teko/ds-desktop';
import { useProductDetailState } from 'contexts';
import React from 'react';
import { ProductVariantItem } from './ProductVariantItem';

export const ProductVariants: React.FC = () => {
  const { product, onSelectVariant } = useProductDetailState();

  const variants = product?.productOptions?.rows;
  if (!product || !product.productOptions?.rows.length) return null;

  return variants ? (
    <>
      {variants.map((variant, index) => (
        <ProductVariantItem
          key={index}
          variant={variant}
          onSelect={onSelectVariant}
        />
      ))}
      {!!product?.clearanceTypeDescription && (
        <Caption level={1} color="textSecondary">
          {product.clearanceTypeDescription}
        </Caption>
      )}
    </>
  ) : (
    <React.Fragment />
  );
};
